import { render, staticRenderFns } from "./InstituteList.vue?vue&type=template&id=d457fcac"
import script from "./InstituteList.vue?vue&type=script&lang=js"
export * from "./InstituteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports